import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")


const __default__ = {
  name: 'salaryFundCheck'
}

import { ref, Ref, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { formatNumber } from '@/utils/index'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { 
  // 发放清单—社保公积金校对
  'GET/salaries/distributes/{id}/check/security': fetchList
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)
const route = useRoute()


const searchConfig: Ref<FromConfig[]> = ref([
{
  type: 'SELECT',
  label: '社保类型',
  value: '',
  upKey: 'search',
  options: [
    { label: '仅清单有社保', id: 'Distribute' },
    { label: '仅清单无社保', id: 'Security' },
    { label: '都有社保', id: 'all' },
    { label: '都无社保', id: 'none' },
  ],
  placeholder: '请选择社保类型',
  seleProps: { },
  props: { clearable: true }
}
])

const searchHandle = (params: object) => {
  fetchData({...params,id: route.params.id}, {} ,1)
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "公积金校验" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              title: true,
              searchConfig: searchConfig.value
            }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "mb-10 mt-10",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/distribution-list'})))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      style: {"width":"1200px"},
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "userName"
        }),
        _createVNode(_component_el_table_column, {
          label: "入职日期",
          prop: "hiredTime"
        }),
        _createVNode(_component_el_table_column, {
          label: "离职日期",
          prop: "departureDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "个人社保合计",
          prop: "personalSocialSecurity",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人公积金",
          prop: "personalHousing",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "校验个人社保合计",
          prop: "checkSocialSecurity",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "校验个人社公积金",
          prop: "checkHousing",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      style: {"float":"none"},
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})